import React, { useState } from "react";
import api from "../api";
import { useNavigate, Link } from "react-router-dom";
import "../App.css";

export default function Register() {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false); // 🔹 état chargement
  const navigate = useNavigate();

  const handleRegister = async (e) => {
    e.preventDefault();
    setLoading(true); // 🔹 démarre le chargement

    try {
      await api.post("/auth/register", { name, email, password });
      alert("Inscription réussie ✅, vous pouvez maintenant vous connecter !");
      navigate("/login");
    } catch (err) {
      alert("Erreur d'inscription");
    } finally {
      setLoading(false); // 🔹 stop le chargement
    }
  };

  return (
    <div className="auth-container">
      <form onSubmit={handleRegister}>
        <h2>Inscription</h2>

        <p
          style={{
            textAlign: "center",
            color: "#94a3b8",
            marginBottom: "10px",
          }}
        >
          Créez votre compte gratuitement
        </p>

        <input
          type="text"
          placeholder="Nom complet"
          value={name}
          onChange={(e) => setName(e.target.value)}
          required
          disabled={loading} // 🔹 désactivé pendant chargement
        />

        <input
          type="email"
          placeholder="Adresse email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
          disabled={loading}
        />

        <input
          type="password"
          placeholder="Mot de passe"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
          disabled={loading}
        />

        <button
          type="submit"
          className="btn-primary"
          disabled={loading} // 🔹 empêche double clic
        >
          {loading ? "Création du compte..." : "S’inscrire maintenant"}
        </button>

        {loading && (
          <p
            style={{
              textAlign: "center",
              marginTop: "10px",
              color: "#00d2ff",
              fontSize: "0.9rem",
            }}
          >
            ⏳ Création de votre compte en cours...
          </p>
        )}

        {!loading && (
          <p
            style={{
              marginTop: "15px",
              textAlign: "center",
              fontSize: "0.9rem",
            }}
          >
            Déjà un compte ?{" "}
            <Link
              to="/login"
              style={{ color: "#00d2ff", textDecoration: "none" }}
            >
              Se connecter
            </Link>
          </p>
        )}
      </form>
    </div>
  );
}
